export const bankData = [
   { _id: 'bpi', name: 'BPI', srcIcon: '/bank/bpi.webp' },
   { _id: 'bdo', name: 'BDO', srcIcon: '/bank/bdo.webp' },
   { _id: 'metrobank', name: 'Metrobank', srcIcon: '/bank/metrobank.webp' },
   { _id: 'unionbank', name: 'Unionbank', srcIcon: '/bank/unionbank.webp' },
   {
      _id: 'securitybank',
      name: 'Security Bank',
      srcIcon: '/bank/securitybank.webp',
   },
   { _id: 'rcbc', name: 'RCBC', srcIcon: '/bank/rcbc.webp' },
   { _id: 'chinabank', name: 'China Bank', srcIcon: '/bank/chinabank.webp' },
   { _id: 'dbp', name: 'DBP', srcIcon: '/bank/dbp.webp' },
   { _id: 'pnb', name: 'PNB', srcIcon: '/bank/pnb.webp' },
   {
      _id: 'landbank',
      name: 'Landbank',
      srcIcon: '/bank/landbank.webp',
   },
   {
      _id: 'gcash',
      name: 'Gcash',
      srcIcon: '/gcashpay.webp',
   },
];
